<template>
  <a
    @click="openService"
    class="service-icon-btn j-service-float-btn"
    :class="[isShowBtn ? 'show' : false]"
    @mouseenter="isShowBtn = true"
    href="javascript:;"
    v-if="showServiceIcon"
  ></a>
</template>

<script>
import bridge from '@utiles/officialStore/bridge';
import globalConfig from '@utiles/officialStore/globalConfig';
import { mapState, mapGetters } from 'vuex';
import jpService from '@mixins/officialStore/jpServiceLink';
import { clickButton } from '@plugins/biPoint/_configWebstoreV1';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const MAIN_HOST = globalConfig.getMainHost();

export default {
  mixins: [jpService],
  props: [
    'serverId',
    'roleId',
    'roleName',
    'gameId',
    'isUidLogin',
    'uid',
    'loginAccount'
  ],
  data() {
    return {
      needBtn: globalConfig.getHrefParam('hideService') != 1,
      isShowBtn: false,
      timer: null
    };
  },
  computed: {
    ...mapState({
      isLogin: state => state.login.isLogin
    }),
    ...mapGetters(['isJpPlatform', 'gameInfoConfig']),
    showServiceIcon() {
      if (this.gameInfoConfig?.serviceShowByLogin) {
        return this.isLogin && this.needBtn;
      } else {
        return this.needBtn;
      }
    }
  },
  watch: {
    isShowBtn(newV) {
      if (newV) {
        this.timer = setTimeout(() => {
          clearTimeout(this.timer);
          this.timer = null;
          this.isShowBtn = false;
        }, 2000);
      } else {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
      }
    }
  },
  methods: {
    globalService() {
      let realPage = `//service.${MAIN_HOST}${
        this.isUidLogin ? `?isUidLogin=1&uid=${this.uid}` : ''
      }`;
      if (globalConfig.getHrefParam('packageName') == '') {
        realPage = `https://gabres.${MAIN_HOST}/platform/webSupport.html?gameId=${
          this.gameId || ''
        }&serverId=${this.serverId || ''}&roleId=${
          this.roleId || ''
        }&roleName=${encodeURIComponent(this.roleName) || ''}${
          this.isUidLogin ? `&isUidLogin=1&uid=${this.uid}` : ''
        }&loginAccount=${this.loginAccount || ''}`;
        window.open(getGlobalGetGotoLink({ link: realPage }), '_blank');
      } else {
        bridge.callSdkMethod('openBrowser', {
          url: getGlobalGetGotoLink({ link: realPage }),
          loginDir: 1,
          appendParams: 1
        });
      }
    },
    openService() {
      clickButton({
        btnName: 'customer_service',
        locationKey: this.$route.meta.pageName
      });
      if (this.isShowBtn) {
        this.isJpPlatform ? this.jpService() : this.globalService();
      } else {
        this.isShowBtn = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';
$w: 106px;
.service-icon-btn {
  z-index: 20;
  position: fixed;
  right: -0.5 * $w;
  bottom: 36vh;
  background-size: contain;
  cursor: pointer;
  transition: all 0.2s;
  @psetbg ('service-ico.png');
  &.show {
    right: 0;
  }
}
@media screen and (orientation: landscape) and (max-width: 1000px) {
  .service-icon-btn {
    right: -20px;
  }
}
</style>
